import React from "react";
import styles from "./DetailMDR.module.css";
import {
  FooterLeft,
  FooterIndex,
  HeaderMDR,
  TableMDR,
  Navbar,
} from "../../components/";
import { HeaderMDRCompany, TableMDRCompany } from "../../components/Company/";
import { useLocation } from "react-router-dom";

const DetailMDR = () => {
  const location = useLocation();
  let data = location.state;

  //Utilizar el sesion storage está limitado a la pestaña o ventana actual, y los datos se borran cuando se cierra la pestaña o ventana.
  if (!data) {
    const storedData = sessionStorage.getItem("reportData");
    if (storedData) {
      data = JSON.parse(storedData);
    }
  } else {
    // Almacena los datos en sessionStorage si están disponibles.
    sessionStorage.setItem("reportData", JSON.stringify(data));
  }

  return (
    <>
      <Navbar />
      <div className={styles.mainContainer}>
        <FooterLeft />
        <div className={styles.container}>
          {data && data.typeCustomer === "Persona Jurídica" ? (
            <>
              <HeaderMDRCompany data={data} />
              <TableMDRCompany data={data} />
            </>
          ) : (
            <>
              <HeaderMDR data={data} />
              <TableMDR data={data} />
            </>
          )}
          <div className={styles.footer}>
            <FooterIndex />
          </div>
        </div>
      </div>
    </>
  );
};

export default DetailMDR;
